import React, { useState, useEffect } from "react";
import { FaRocket } from "react-icons/fa";
import "./RocketButton.css";

const RocketButton = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisibility = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) {
      setVisible(true);
    } else if (scrolled <= 300) {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <div
      className={`rocket-button ${visible ? "show" : "hide"}`}
      onClick={scrollToTop}
    >
      <FaRocket className="rocket-icon" />
    </div>
  );
};

export default RocketButton;
